// 編集画面のフロートメニュー
$(() => {
	let menu = $('#js-floatFormMenu');
	if(menu.length >0){
		menu.fadeIn(300);
		floatFormMenuRePosition();
	}

	// ブラウザリサイズ時の処理
	// var resizeTimer = null;
	// $(window).on('resize', function() {
	// 	clearTimeout(resizeTimer);
	// 	resizeTimer = setTimeout(function() {
	// 		var winWidth = $(window).width();
	// 		var winHeight = $(window).height();
	// 		floatFormMenuRePosition();
	// 	}, 200);
	// });
});


// 位置調整
var floatFormMenuRePosition = function(v) {
	// var elemH = $('#js-floatFormMenu').outerHeight();
	// var windowH = $(window).height();
};
